import {useTheme} from '@mui/material';

export default function ArrowDownIcon() {
	const theme = useTheme();
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path d="M12.0469 9.62012L8.00021 13.6668L3.95354 9.62012"
			      stroke={theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.primary.main}
			      strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M8 2.33325L8 13.5533"
			      stroke={theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.primary.main}
			      strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	);
}
